import { Container as MTContainer } from "@mantine/core";

interface IContainerProps {
  children: React.ReactNode;
  className?: string;
}

const SSContainer: React.FC<IContainerProps> = ({ children, className }) => {
  return (
    <MTContainer className={className} size={1440}>
      {children}
    </MTContainer>
  );
};

export default SSContainer;
